let setupDone = false;

// Calling this function initializes variables etc and returns:
//  a function "start" that will start the animation
//  a function "stop" that will stop the animation
//  false in case the setup was already done or there is no #snow canvas
// You can only call this function once so keep these helper functions in a ref
export const snowUtil = (): { start: () => void; stop: () => void } | false => {
    if (setupDone) return false;
    setupDone = true;

    const c = document.getElementById("snow");
    if (!(c instanceof HTMLCanvasElement)) {
        return false;
    }
    let stopLoop = false;
    const $ = c.getContext("2d");
    c.width = window.innerWidth;
    c.height = window.innerHeight;
    const w = c.width;
    const h = c.height;
    const arr: Flake[] = [];
    const num = 600;
    const tsc = 1;
    const sp = 1;
    const sc = 1.3;
    const mv = 20;
    const min = 1;

    const go = (): void => {
        if (stopLoop) return;
        window.requestAnimationFrame(go);
        $?.clearRect(0, 0, w, h);
        for (let i = 0; i < arr.length; ++i) {
            const f = arr[i];
            f.t += 0.05;
            f.t = f.t >= Math.PI * 2 ? 0 : f.t;
            f.y += f.sp;
            f.x += Math.sin(f.t * tsc) * (f.sz * 0.3);
            if (f.y > h + 50) f.y = -10 - Math.random() * mv;
            if (f.x > w + mv) f.x = -mv;
            if (f.x < -mv) f.x = w + mv;
            f.draw();
        }
    };

    if ($) {
        for (let i = 0; i < num; ++i) {
            const szValue = (100 / (10 + Math.random() * 100)) * sc;
            const spValue = (szValue * 0.8) ** 2 * 0.15 * sp;
            arr.push(
                new Flake({
                    context: $,
                    y: Math.random() * (h + 50),
                    x: Math.random() * w,
                    t: Math.random() * (Math.PI * 2),
                    sz: szValue,
                    sp: spValue < min ? min : spValue,
                }),
            );
        }
    }

    const start = (): void => {
        stopLoop = false;
        go();
    };
    const stop = (): void => {
        stopLoop = true;
        $?.clearRect(0, 0, w, h);
    };
    return { start, stop };
};

type FlakeProps = {
    context: CanvasRenderingContext2D;
    x: number;
    y: number;
    t: number;
    sz: number;
    sp: number;
};

class Flake {
    private context: CanvasRenderingContext2D;

    constructor(props: FlakeProps) {
        this.context = props.context;
        this.x = props.x;
        this.y = props.y;
        this.t = props.t;
        this.sz = props.sz;
        this.sp = props.sp;
    }

    x: number;

    y: number;

    t: number;

    sz: number;

    sp: number;

    private g?: CanvasGradient;

    draw(): void {
        this.g = this.context.createRadialGradient(this.x, this.y, 0, this.x, this.y, this.sz);
        this.g.addColorStop(0, "hsla(255,255%,255%,1)");
        this.g.addColorStop(1, "hsla(255,255%,255%,0)");
        this.context.moveTo(this.x, this.y);
        this.context.fillStyle = this.g;
        this.context.beginPath();
        this.context.arc(this.x, this.y, this.sz, 0, Math.PI * 2, true);
        this.context.fill();
    }
}
